module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-block"
  }, [_c('i', {
    staticClass: "fa fa-question-circle font-blue clickable",
    attrs: {
      "id": ("popover-id-" + _vm.id)
    },
    on: {
      "click": function($event) {
        _vm.openPopover()
      }
    }
  }), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "popover-styles",
    class: {
      'shift-left': _vm.rightSide
    }
  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31776268!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/InfoPopover.vue
// module id = 419
// module chunks = 1